<div class="dialog-overlay-spinner" *ngIf="!hasLoadSuccess">
    <app-overlay-spinner [diameter]="120" [mode]="'indeterminate'"></app-overlay-spinner>
</div>

<app-create-edit-with-tree (confirmEmitter)="confirmEmitter($event)" [data]="inputData"></app-create-edit-with-tree>